// The dock's mini player (owner 2026-10-21, Android dock/MiniPlayer.kt `miniPlayerIndex`): minimised, the dock shows
// one player at the bottom of the viewport. Figma: Android / Dock / Mini player 4304:10630 (shared with web);
// Web / Dock / Mini player screens 4308:11316, 4308:11397, 4308:11560, 4308:11595.

/** The live card's key in the dock's player list. */
export const LIVE_KEY = "live";
/** The wall card's key in the dock's player list. */
export const WALL_KEY = "wall";
/** The chat link card's key (link kinds step 2); never in the dock with the wall card. */
export const CHAT_LINK_KEY = "chat-link";

export interface DockPlayerRef {
  /** LIVE_KEY, WALL_KEY, CHAT_LINK_KEY or the cast's key. */
  key: string;
  kind: "live" | "own" | "watched" | "wall" | "chatLink";
  /**
   * Your own link cast on a YouTube / SoundCloud item: its player ends items for everyone, so it cannot hold and is
   * never the one hidden.
   */
  drivesItems?: boolean;
}

const RANK: Record<DockPlayerRef["kind"], number> = { live: 0, own: 1, watched: 2, wall: 3, chatLink: 3 };

/**
 * Which player the mini player shows: your own YouTube / SoundCloud cast first, then the player the user minimised
 * ([preferred]) while it is still in the dock, then the PiP priority live > own casts > watched casts > wall (dock
 * order within each). Null when the dock is empty.
 */
export function miniPlayerKey(players: DockPlayerRef[], preferred: string | null): string | null {
  if (players.length === 0) return null;
  const driver = players.find((p) => p.drivesItems);
  if (driver) return driver.key;
  if (preferred != null && players.some((p) => p.key === preferred)) return preferred;
  let best = players[0];
  for (const p of players) if (RANK[p.kind] < RANK[best.kind]) best = p;
  return best.key;
}
